import { Box, SimpleGrid, Skeleton, Stack } from '@mantine/core';
import { LauncherShell } from '../components/LauncherShell';

/** Branded loading chrome — skeleton tiles instead of a bare spinner so
 *  the launcher frame is visible immediately while the session resolves. */
export function LoadingState() {
  return (
    <LauncherShell>
      <Stack gap="xl">
        <Box>
          <Skeleton height={28} width={220} radius="sm" />
          <Skeleton height={14} width={340} radius="sm" mt={10} />
        </Box>
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} height={108} radius="md" />
          ))}
        </SimpleGrid>
      </Stack>
    </LauncherShell>
  );
}
